export default function PurposeSection() {
  return (
    <section className="bg-white-pure w-full py-20 px-6">
      <div className="max-w-5xl mx-auto">

        {/* Header */}
        <div className="flex flex-col items-center text-center gap-4 mb-14">
          <div className="flex items-center gap-3">
            <div className="w-1 h-4 bg-blue-dark rounded-full opacity-60" />
            <span
              className="font-cinzel text-blue-dark uppercase tracking-widest"
              style={{ fontSize: "11px", letterSpacing: "0.2em" }}
            >
              Purpose &amp; Direction
            </span>
            <div className="w-1 h-4 bg-blue-dark rounded-full opacity-60" />
          </div>

          <h2
            className="font-cinzel font-bold text-blue-dark uppercase"
            style={{
              fontSize: "clamp(22px, 3.5vw, 38px)",
              letterSpacing: "0.06em",
              lineHeight: "1.15",
            }}
          >
            Our Mission &amp; Our Promise
          </h2>
        </div>

        {/* Two cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

          {/* Mission card */}
          <div
            className="rounded-2xl border p-8 flex flex-col gap-5 bg-white-warm transition-all duration-200 hover:shadow-md"
            style={{ borderColor: "rgba(1,46,114,0.12)" }}
          >
            {/* Icon */}
            <div
              className="w-11 h-11 rounded-full flex items-center justify-center text-blue-dark"
              style={{ backgroundColor: "rgba(1,46,114,0.08)" }}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
            </div>

            <div>
              <h3
                className="font-cinzel font-bold text-blue-dark uppercase tracking-wider"
                style={{ fontSize: "13px", letterSpacing: "0.16em" }}
              >
                Our Mission
              </h3>
              <div className="h-px w-10 bg-blue-dark mt-2" style={{ opacity: 0.2 }} />
            </div>

            <p
              className="font-constantia text-black-deep leading-relaxed"
              style={{ fontSize: "15.5px", opacity: 0.7 }}
            >
              Our mission is to provide you with the quality service and care
              that you deserve. We understand the unique challenges of owning and
              operating a business. This is why we are dedicated to providing you
              with hassle-free insurance service that best suits your needs.
            </p>
          </div>

          {/* Promise card */}
          <div
            className="rounded-2xl border p-8 flex flex-col gap-5 transition-all duration-200 hover:shadow-md"
            style={{
              backgroundColor: "#012E72",
              borderColor: "rgba(255,255,255,0.08)",
            }}
          >
            {/* Icon */}
            <div
              className="w-11 h-11 rounded-full flex items-center justify-center text-white-pure"
              style={{ backgroundColor: "rgba(255,255,255,0.12)" }}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
            </div>

            <div>
              <h3
                className="font-cinzel font-bold text-white-pure uppercase tracking-wider"
                style={{ fontSize: "13px", letterSpacing: "0.16em" }}
              >
                Our Promise
              </h3>
              <div className="h-px w-10 bg-white-pure mt-2" style={{ opacity: 0.2 }} />
            </div>

            <p
              className="font-constantia text-white-pure leading-relaxed"
              style={{ fontSize: "15.5px", opacity: 0.78 }}
            >
              With agents that have over 20 years of experience in the insurance
              industry, we are here to serve you. We promise to:
            </p>

            <ul className="flex flex-col gap-3">
              {[
                "Find you the correct coverage at an unbeatable price",
                "Provide one-on-one guidance through every step of the process",
                "Treat every client as we would our own family",
                "Deliver peace of mind — knowing you're covered at a fair rate",
              ].map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <div className="mt-1.5 w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: "rgba(255,255,255,0.12)" }}>
                    <svg width="8" height="8" viewBox="0 0 10 10" fill="none">
                      <polyline points="1.5 5 4 7.5 8.5 2.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <span
                    className="font-constantia text-white-pure leading-relaxed"
                    style={{ fontSize: "15px", opacity: 0.75 }}
                  >
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}